'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _require = require('abstract-leveldown'),
    AbstractIterator = _require.AbstractIterator;

var inherits = require('inherits');

var getCallback = require('./util').getCallback;

var kOptions = Symbol('options');
var kIterator = Symbol('iterator');
var kOperations = Symbol('operations');
var kPromise = Symbol('promise');

function DeferredIterator(db, options) {
  AbstractIterator.call(this, db);
  this[kOptions] = options;
  this[kIterator] = null;
  this[kOperations] = [];
}

inherits(DeferredIterator, AbstractIterator);

DeferredIterator.prototype.setDb = function (db) {
  this[kIterator] = db.iterator(this[kOptions]);

  var _iterator = _createForOfIteratorHelper(this[kOperations].splice(0, this[kOperations].length)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _this$kIterator;

      var op = _step.value;

      (_this$kIterator = this[kIterator])[op.method].apply(_this$kIterator, _toConsumableArray(op.args));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

DeferredIterator.prototype.next = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (this.db.status === 'open') {
    var _this$kIterator2;

    return (_this$kIterator2 = this[kIterator]).next.apply(_this$kIterator2, args);
  }

  var callback = getCallback(args, kPromise, function map(key, value) {
    if (key === undefined && value === undefined) {
      return undefined;
    } else {
      return [key, value];
    }
  });

  if (this.db.status === 'opening') {
    this[kOperations].push({
      method: 'next',
      args: args
    });
  } else {
    this._nextTick(callback, new Error('Database is not open'));
  }

  return callback[kPromise] || this;
};

DeferredIterator.prototype.seek = function () {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (this.db.status === 'open') {
    var _this$kIterator3;

    (_this$kIterator3 = this[kIterator]).seek.apply(_this$kIterator3, args);
  } else if (this.db.status === 'opening') {
    this[kOperations].push({
      method: 'seek',
      args: args
    });
  } else {
    throw new Error('Database is not open');
  }
};

DeferredIterator.prototype.end = function () {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  if (this.db.status === 'open') {
    var _this$kIterator4;

    return (_this$kIterator4 = this[kIterator]).end.apply(_this$kIterator4, args);
  }

  var callback = getCallback(args, kPromise);

  if (this.db.status === 'opening') {
    this[kOperations].push({
      method: 'end',
      args: args
    });
  } else {
    this._nextTick(callback, new Error('Database is not open'));
  }

  return callback[kPromise] || this;
};

var _loop = function _loop() {
  var method = _arr[_i];

  DeferredIterator.prototype['_' + method] = function () {
    /* istanbul ignore next: assertion */
    throw new Error('Did not expect private method to be called: ' + method);
  };
};

for (var _i = 0, _arr = ['next', 'seek', 'end']; _i < _arr.length; _i++) {
  _loop();
}

module.exports = DeferredIterator;